export default __webpack_public_path__ + "static/media/news.0575f0ef.svg";